
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderDetailBilling"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderDetailBilling"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"companyTax"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"companyAddress"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":97}};
    doc.loc.source = {"body":"fragment OrderDetailBilling on OrderDetailBilling {\n  companyName\n  companyTax\n  companyAddress\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
